import { Link } from "@tanstack/react-router";
import { EmptyState } from "@platform/ui";
import { PageCard } from "../layout/Page";

export function NotFoundPage() {
  return (
    <PageCard>
      <EmptyState
        title="404"
        action={
          <Link to="/" className="text-primary-dark hover:underline">
            ←
          </Link>
        }
      />
    </PageCard>
  );
}
